import { Route, Switch, Redirect } from "react-router-dom";

import Login from "../pages/Login";
import Files from "../pages/External/Archives";
import {LinkQuestions} from "../pages/External/LinkQuestions";
function AuthRoutes() {
	return (
		<Switch>
			<Route path='/' exact>
				<Login />
			</Route>

			<Route path='/anexar'>
				<Files />
			</Route>

			<Route path='/conectarQuestoes'>
				<LinkQuestions />
			</Route>

			<Redirect to='/' />
		</Switch>
	);
}

export default AuthRoutes;
